import { ButtonVariant, CoButton } from "components/CoButton";
import SearchResultsList from "features/SearchResultsList/SearchResultsList";
import { Paper } from "helpers/api";
import { MixpanelActionSource } from "helpers/services/mixpanel/events";
import useLabels from "hooks/useLabels";

type RelatedPapersTabProps = {
  selectedTab: RelatedTab;
  onClickSave: (paper: Paper) => void;
  onClickLoadMore: () => void;
  relatedPapers: Paper[];
  canLoadMore: boolean;
  isLoading: boolean;
  isError: boolean;
  mixpanelActionSource?: MixpanelActionSource;
};

export enum RelatedTab {
  Citations = "Citations",
  References = "References",
}

function RelatedPapersTab({
  selectedTab,
  onClickSave,
  onClickLoadMore,
  relatedPapers,
  canLoadMore,
  isLoading,
  isError,
}: RelatedPapersTabProps) {
  const [generalLabels] = useLabels("general");

  const mixpanelActionSource =
    selectedTab === "Citations"
      ? MixpanelActionSource.CitationList
      : MixpanelActionSource.ReferenceList;

  if (isError || (!isLoading && !relatedPapers.length)) {
    return null;
  }

  return (
    <>
      <div>
        <SearchResultsList
          isLoading={isLoading}
          items={relatedPapers}
          showCiteBtn
          showSaveBtn
          showShareBtn
          resultIdToYesNoAnswer={{}}
          mixpanelActionSource={mixpanelActionSource}
          onClickSave={onClickSave}
        />
        {canLoadMore && (
          <div className="flex justify-center my-6">
            <CoButton
              data-testid={`loadmore-button-${selectedTab}`}
              onClick={onClickLoadMore}
              disabled={isLoading}
              size="sm"
              variant={ButtonVariant.Tertiary}
              label={generalLabels["load-more"]}
              iconRight="icon-chevron-down"
            />
          </div>
        )}
      </div>
    </>
  );
}

export default RelatedPapersTab;
